module.exports = __webpack_public_path__ + "assets/fonts/dashboard.07d7f4fb.svg";